module.exports = __webpack_public_path__ + "assets/img/active-img1.ab0ee53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activities/active-img1.jpg
// module id = Mw/t
// module chunks = 1